import { useApiData } from 'lib/api';
import { EmptyIndicator, Owners, TitleWithIcon } from 'components/common';
import { Box, BoxRow } from 'components/common/box';
import { useReduxState } from 'hooks';

const GroupPaths = () => {
  const {
    messages,
    pageState: { group },
    theme
  } = useReduxState();

  const { data, loading } = useApiData({
    url: `/admin/groups/${group.id}/paths`
  });

  return (
    <div className="paths">
      <Box
        loading={loading}
        padding={0}
        title={messages.paths}
        titleTooltip={messages.groupsPathsInfo}
      >
        {data?.paths?.length ? (
          data.paths.map((path) => (
            <BoxRow key={path.id}>
              <div className="row row-center">
                <div className="col">
                  <TitleWithIcon
                    icon="tasks"
                    title={path.title}
                    titleLink={{
                      as: `/admin/paths/${path.id}`,
                      href: '/admin/paths/[pathId]'
                    }}
                  >
                    <Owners owners={path.owners} />
                  </TitleWithIcon>
                </div>
                <div className="col-min">
                  <div className="courses">
                    {`${path.numberOfCourses} ${messages.commonCoursesPlural}`}
                  </div>
                </div>
              </div>
            </BoxRow>
          ))
        ) : (
          <EmptyIndicator
            icon="tasks"
            size="small"
            title={messages.pathsEmpty}
          />
        )}
      </Box>

      <style jsx>{`
        .courses {
          color: ${theme.textColorLight};
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default GroupPaths;
